export default "__VITE_ASSET__CjaYYpda__"